export default "__VITE_ASSET__BBxuOvD8__"